module.exports = __webpack_public_path__ + "static/media/icon_advanced_metrics.f9788672.svg";